<template>
  <div>
    <div class="main-container">
      <Navbar />

      <div class="content-container">
        <router-view />
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from '@/layout/Navbar.vue';
import Footer from '@/layout/Footer.vue';
import Storage from '@/helpers';
import config from '@/config';

const DEFAULT_TITLE = 'Marketplace';
const BLOCK_TIME = config.blockTime;
export default {
  name: 'App',
  components: { Navbar, Footer },
  data() {
    return {
      intervalRefetchBalance: null
    };
  },
  computed: {
    myAccount() {
      return this.$store.state.auth.address;
    }
  },
  watch: {
    $route(to) {
      document.title = `${DEFAULT_TITLE} - ${to.meta.title}`;
    },
    myAccount() {
      this.generateTokenIfNeed();
      this.intervalRefetchBalance = setInterval(() => {
        this.$store.dispatch('myAccount/fetchBalances');
      }, 3 * BLOCK_TIME);
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalRefetchBalance);
  },
  async mounted() {
    this.generateTokenIfNeed();
  },
  async created() {
    try {
      const connectorId = Storage.getConnectorId();
      if (connectorId) {
        await this.$store.dispatch('auth/connect', connectorId);
      }
      // this.fetchMetaData();
    } catch (e) {
      // const message = this.handleTransactionError(e);
      // this.$dialog.notify.error(message);

      console.error(e);
      throw e;
    }
  },
  methods: {
    async generateTokenIfNeed() {
      if (this.myAccount && !Storage.getToken() && !this.wrongNetwork) {
        await this.$store.dispatch('auth/generateToken');
      }
      await this.$store.dispatch('myAccount/fetchBalances');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '././assets/style/variables.scss';
@import 'assets/font/iconfont.css';

.main-container {
  background-color: #ffffff;
  z-index: 4;
  min-height: 100vh;

  .content-container {
    width: 1366px;
    margin: 0 auto;
  }
}

@media (max-width: $breakpoint-desktop) {
  .main-container {
    .content-container {
      width: 90vw;
    }
  }
}
@media (max-width: $breakpoint-mobile) {
  .main-container {
    .content-container {
      width: 95vw;
    }
  }
}
</style>
